module.exports = __webpack_public_path__ + "img/img-14.362f60d9.png";